import type { IconProps } from './types';

function LockIcon(props: IconProps) {
  const { size = 24, color = 'currentColor', ref, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...other}
    >
      <path
        d="M7.3125 11.0625V6.375C7.3125 3.78617 9.41117 1.6875 12 1.6875C14.5888 1.6875 16.6875 3.78617 16.6875 6.375V11.0625M14.8125 16.6875H9.1875M20.4375 11.0625H3.5625V22.3125H20.4375V11.0625Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </svg>
  );
}

export { LockIcon };
